import { useTranslation } from 'react-i18next';
import { Icon } from '../../ui/index.ts';
import { useGame } from '../GameContext.tsx';
import { PLAN_VIEW_ID } from '../useGameKeys.ts';
import styles from './RouteStrip.module.css';

/** The plan as a line of stops: where the team has been, where it is, what is left. */
export function RouteStrip() {
  const { t } = useTranslation('game');
  const { view, g } = useGame();
  const exec = view.exec;
  if (!exec) return null;
  return (
    <nav id={PLAN_VIEW_ID} tabIndex={-1} className={styles['strip']} aria-label={t('route.label')}>
      <ol className={styles['list']}>
        {exec.stops.map((s, i) => {
          const name = s.room ? g(`rooms.${s.room}`) : '';
          const text =
            s.kind === 'room'
              ? name
              : s.kind === 'corridor'
                ? t('route.corridor', { room: name })
                : s.kind === 'rope'
                  ? t('route.rope')
                  : t('route.back', { room: name });
          return (
            <li
              key={i}
              aria-current={s.status === 'active' ? 'step' : undefined}
              className={[
                styles['stop'],
                styles[s.status],
                s.optional ? styles['optional'] : '',
                s.skipped ? styles['skipped'] : '',
              ].join(' ')}
            >
              {s.status === 'done' ? <Icon name="check" size="1em" /> : null}
              <span>{text}</span>
            </li>
          );
        })}
        <li
          className={[styles['stop'], view.game.phase === 'escape' ? styles['active'] : ''].join(
            ' ',
          )}
        >
          <span>{t('route.escape')}</span>
        </li>
      </ol>
    </nav>
  );
}
